var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-dialog",
    {
      attrs: {
        visible: _vm.states.isShowAIDrawer,
        "destroy-on-close": true,
        "show-header": true,
        modal: false,
        "append-to-body": true,
        "before-close": _vm.beforeClose,
        "lock-scroll": true,
        fullscreen: true,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.states, "isShowAIDrawer", $event)
        },
        closed: _vm.closed,
      },
    },
    [
      _c("span", { attrs: { slot: "mainTitle" }, slot: "mainTitle" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("pc_biz_ote_btn_aicreateques")) + "\n  "
        ),
      ]),
      _c(
        "span",
        { attrs: { slot: "headerRight" }, slot: "headerRight" },
        [
          _c(
            "yxt-button",
            {
              attrs: {
                loading: _vm.saving,
                type: "primary",
                disabled: !_vm.isReady,
              },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirmImport")))]
          ),
        ],
        1
      ),
      _vm.quesLevelTypeInited
        ? _c("intelligent-create-ques", {
            ref: "aiQuesCreator",
            attrs: {
              libId: this.states.libId,
              examId: this.states.examId,
              type: this.states.type,
              aiEnable: this.aiEnable,
            },
            on: {
              created: _vm.quesCreated,
              createReadyChange: _vm.createReadyChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }